(function () {
  'use strict';

  var root = document.documentElement;
  var OPEN_CLASS = 'atlekx-mega-open';
  var SOLID_CLASS = 'atlekx-mega-solid';
  var MEGA_DETAILS = '.site-nav--is-megamenu .site-nav__details';
  var closeTimers = new WeakMap();

  function closeDelay() {
    var header = document.getElementById('SiteHeader');
    if (!header) return 250;
    var raw = parseInt(header.getAttribute('data-atlekx-close-delay'), 10);
    return isNaN(raw) ? 250 : raw;
  }

  function navBreakpoint() {
    var header = document.getElementById('SiteHeader');
    if (!header) return 769;
    var raw = parseInt(header.getAttribute('data-atlekx-nav-bp'), 10);
    return isNaN(raw) ? 769 : raw;
  }

  function cancelClose(detail) {
    var timer = closeTimers.get(detail);
    if (timer) {
      window.clearTimeout(timer);
      closeTimers.delete(detail);
    }
  }

  function cancelAllCloses() {
    getMegaDetails().forEach(cancelClose);
  }

  function closeDetail(detail) {
    detail.removeAttribute('open');
    detail.setAttribute('aria-expanded', 'false');
    var summary = detail.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }

  function getAllNavDetails() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-section-type="header"] .site-nav__details')
    );
  }

  function closeDetailInstant(detail) {
    cancelClose(detail);
    detail.classList.add('atlekx-instant');
    closeDetail(detail);
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        detail.classList.remove('atlekx-instant');
      });
    });
  }

  function closeSiblings(current) {
    var changed = false;
    getAllNavDetails().forEach(function (other) {
      if (other !== current && other.hasAttribute('open')) {
        closeDetailInstant(other);
        changed = true;
      }
    });
    return changed;
  }

  function scheduleClose(detail) {
    cancelClose(detail);
    var delay = closeDelay();

    if (delay <= 0) {
      closeDetail(detail);
      syncState();
      return;
    }

    closeTimers.set(
      detail,
      window.setTimeout(function () {
        closeTimers.delete(detail);
        if (detail.matches(':hover')) return;
        closeDetail(detail);
        syncState();
      }, delay)
    );
  }

  function getHeaderBottom() {
    var header = document.getElementById('SiteHeader') || document.querySelector('.site-header');
    if (!header) return 0;
    var rect = header.getBoundingClientRect();
    return Math.max(0, Math.round(rect.bottom));
  }

  function updateMegaTop() {
    root.style.setProperty('--atlekxMegaTop', getHeaderBottom() + 'px');
  }

  function ensureScrim() {
    var scrim = document.querySelector('.atlekx-mega-scrim');
    if (!scrim) {
      scrim = document.createElement('div');
      scrim.className = 'atlekx-mega-scrim';
      document.body.appendChild(scrim);
      scrim.addEventListener('click', closeAllMega);
    }
    return scrim;
  }

  function getMegaDetails() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.site-nav--is-megamenu .site-nav__details')
    );
  }

  function anyOpen() {
    return getMegaDetails().some(function (d) {
      return d.hasAttribute('open');
    });
  }

  function closeAllMega() {
    getMegaDetails().forEach(function (d) {
      cancelClose(d);
      closeDetail(d);
    });
    root.classList.remove(OPEN_CLASS);
    root.classList.remove(SOLID_CLASS);
  }

  function solidHeaderEnabled() {
    var header = document.getElementById('SiteHeader');
    if (!header) return false;
    if (header.getAttribute('data-atlekx-solid-nav') !== 'true') return false;
    return header.getAttribute('data-overlay') === 'true';
  }

  function syncState() {
    if (anyOpen()) {
      updateMegaTop();
      root.classList.add(OPEN_CLASS);
      if (solidHeaderEnabled()) {
        root.classList.add(SOLID_CLASS);
      }
    } else {
      root.classList.remove(OPEN_CLASS);
      root.classList.remove(SOLID_CLASS);
    }
  }

  function initMegaMenu() {
    ensureScrim();
    updateMegaTop();

    var details = getMegaDetails();
    if (!details.length) return;

    details.forEach(function (d) {
      if (d.getAttribute('data-atlekx-bound') === 'true') return;
      d.setAttribute('data-atlekx-bound', 'true');
      d.addEventListener('toggle', function () {
        if (d.hasAttribute('open')) {
          cancelClose(d);
          closeSiblings(d);
        }
        syncState();
      });
    });

    if (root.getAttribute('data-atlekx-global') !== 'true') {
      root.setAttribute('data-atlekx-global', 'true');

      document.addEventListener(
        'mouseleave',
        function (event) {
          var target = event.target;
          if (!target || target.nodeType !== 1 || !target.matches) return;
          if (!target.matches(MEGA_DETAILS)) return;
          event.stopImmediatePropagation();
          if (target.hasAttribute('open')) scheduleClose(target);
        },
        true
      );

      document.addEventListener(
        'mouseover',
        function (event) {
          var target = event.target;
          if (!target || !target.closest) return;

          var detail = target.closest('.site-nav__details');
          if (!detail) return;

          cancelClose(detail);
          if (closeSiblings(detail)) syncState();
        },
        true
      );

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.keyCode === 27) closeAllMega();
      });

      window.addEventListener('resize', function () {
        updateMegaTop();
        if (window.innerWidth < navBreakpoint()) closeAllMega();
      });

      window.addEventListener(
        'scroll',
        function () {
          if (root.classList.contains(OPEN_CLASS)) updateMegaTop();
        },
        { passive: true }
      );
    }
  }

  function initMobilePanels() {
    var viewports = document.querySelectorAll('[data-mnav-viewport]');
    if (!viewports.length) return;

    Array.prototype.forEach.call(viewports, function (viewport) {
      if (viewport.getAttribute('data-atlekx-bound') === 'true') return;
      viewport.setAttribute('data-atlekx-bound', 'true');

      var container = viewport.closest('.atlekx-drawer') || document;
      var backBtn = container.querySelector('[data-mnav-back]');
      var titleEl = container.querySelector('[data-mnav-title]');
      var rootTitle = titleEl ? titleEl.textContent.trim() : '';
      var panels = viewport.querySelectorAll('[data-mnav-panel]');
      var stack = ['root'];

      function panelById(id) {
        return viewport.querySelector('[data-mnav-panel="' + id + '"]');
      }

      function headingOf(id) {
        if (id === 'root') return rootTitle;
        var panel = panelById(id);
        return (panel && panel.getAttribute('data-mnav-heading')) || rootTitle;
      }

      function render() {
        var currentId = stack[stack.length - 1];
        Array.prototype.forEach.call(panels, function (panel) {
          var id = panel.getAttribute('data-mnav-panel');
          panel.classList.remove('is-active', 'is-past');
          if (id === currentId) {
            panel.classList.add('is-active');
            panel.scrollTop = 0;
          } else if (stack.indexOf(id) !== -1) {
            panel.classList.add('is-past');
          }
        });

        if (titleEl) titleEl.textContent = headingOf(currentId);

        if (backBtn) {
          if (stack.length > 1) {
            backBtn.removeAttribute('hidden');
            var label = backBtn.querySelector('[data-mnav-back-label]');
            if (label) label.textContent = headingOf(stack[stack.length - 2]);
          } else {
            backBtn.setAttribute('hidden', 'hidden');
          }
        }
      }

      viewport.addEventListener('click', function (event) {
        var opener = event.target.closest('[data-mnav-open]');
        if (!opener || !viewport.contains(opener)) return;
        event.preventDefault();
        var targetId = opener.getAttribute('data-mnav-open');
        if (!panelById(targetId)) return;
        stack.push(targetId);
        render();
      });

      if (backBtn) {
        backBtn.addEventListener('click', function (event) {
          event.preventDefault();
          if (stack.length > 1) {
            stack.pop();
            render();
          }
        });
      }

      var closeBtn = container.querySelector('.js-drawer-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          window.setTimeout(function () {
            stack = ['root'];
            render();
          }, 400);
        });
      }

      render();
    });
  }

  function boot() {
    initMegaMenu();
    initMobilePanels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
